import url from './url';

async function handleDepoimentos() {

    let data = await fetch(`${url}/depoimentos`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { handleDepoimentos }